import React, { useMemo } from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import PreferencesDataTable from '../../../../components/common/PreferencesDataTable';
import { formatDateOnly } from '../../../../utils/dateUtils';

const formatNumber = (value) => {
    if (value == null || value === '') {
        return '-';
    }
    return Number(value).toLocaleString('tr-TR');
};

const formatAmount = (value) => {
    if (value == null || value === '') {
        return '-';
    }
    return Number(value).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const UnpickedPartsReportTable = ({ items, lazyParams, totalRecords, loading, onPage }) => {
    const { th } = useLanguage();

    const rows = useMemo(
        () =>
            (Array.isArray(items) ? items : []).map((item, index) => ({
                ...item,
                _rowId: `${item.deliveryNo || ''}-${item.invoiceNo || ''}-${item.eFaturaNo || item.efaturaNo || ''}-${item.partCode || ''}-${lazyParams.first}-${index}`
            })),
        [items, lazyParams.first]
    );

    const columns = useMemo(
        () => [
            { field: 'dealerName', header: th('unpickedPartsReport.columns.dealerName'), sortable: true, style: { minWidth: '14rem' } },
            { field: 'countryCode', header: th('unpickedPartsReport.columns.countryCode'), sortable: true, style: { minWidth: '7rem' } },
            { field: 'invoiceNo', header: th('unpickedPartsReport.columns.invoiceNo'), sortable: true, style: { minWidth: '10rem' }, body: (row) => row.invoiceNo || '-' },
            { field: 'eFaturaNo', header: th('unpickedPartsReport.columns.eFaturaNo'), sortable: true, style: { minWidth: '10rem' }, body: (row) => row.eFaturaNo || row.efaturaNo || row.efaturano || '-' },
            { field: 'deliveryNo', header: th('unpickedPartsReport.columns.deliveryNo'), sortable: true, style: { minWidth: '10rem' }, body: (row) => row.deliveryNo || '-' },
            { field: 'partCode', header: th('unpickedPartsReport.columns.partCode'), sortable: true, style: { minWidth: '10rem' } },
            { field: 'partName', header: th('unpickedPartsReport.columns.partName'), sortable: true, style: { minWidth: '14rem' } },
            { field: 'invoiceQuantity', header: th('unpickedPartsReport.columns.invoiceQuantity'), sortable: true, style: { minWidth: '9rem' }, body: (row) => formatNumber(row.invoiceQuantity) },
            { field: 'receivedQuantity', header: th('unpickedPartsReport.columns.receivedQuantity'), sortable: true, style: { minWidth: '9rem' }, body: (row) => formatNumber(row.receivedQuantity) },
            {
                field: 'unreceivedQuantity',
                header: th('unpickedPartsReport.columns.unreceivedQuantity'),
                sortable: true,
                style: { minWidth: '10rem', fontWeight: 600 },
                body: (row) => formatNumber(row.unreceivedQuantity)
            },
            { field: 'documentDate', header: th('unpickedPartsReport.columns.documentDate'), sortable: true, style: { minWidth: '10rem' }, body: (row) => formatDateOnly(row.documentDate) },
            { field: 'totalAmount', header: th('unpickedPartsReport.columns.totalAmount'), sortable: true, style: { minWidth: '10rem' }, body: (row) => formatAmount(row.totalAmount) }
        ],
        [th]
    );

    return (
        <PreferencesDataTable
            tableKey="unpicked-parts-report-v3"
            columns={columns}
            value={rows}
            lazy
            paginator
            first={lazyParams.first}
            rows={lazyParams.rows}
            onPage={onPage}
            totalRecords={totalRecords}
            loading={loading}
            emptyMessage={th('common.noRecords')}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="_rowId"
            tableStyle={{ minWidth: '70rem' }}
            showGridlines
            stripedRows
            scrollable
            scrollHeight="flex"
        />
    );
};

export default UnpickedPartsReportTable;
